import type { PageMetadata } from "@moment/api-collab/api-types";

export const getPageDisplayTitle = (title: string): string => title || "Untitled";

export const isPageDisplayTitleUnique = (
	title: string,
	currentPageId: string | undefined,
	pages: PageMetadata[]
): boolean => {
	const displayTitle = getPageDisplayTitle(title);

	return !pages.some(
		(page) => page.id !== currentPageId && getPageDisplayTitle(page.title) === displayTitle
	);
};

export const generateUniquePageTitle = (
	title: string,
	currentPageId: string | undefined,
	pages: PageMetadata[]
): string => {
	if (isPageDisplayTitleUnique(title, currentPageId, pages)) {
		return title;
	}

	const baseTitle = getPageDisplayTitle(title).trim() || "Untitled";
	let suffix = 2;

	while (!isPageDisplayTitleUnique(`${baseTitle} ${suffix}`, currentPageId, pages)) {
		suffix++;
	}

	return `${baseTitle} ${suffix}`;
};
